import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import icon from 'src/assets/copy.png'
import {
  ModalClose,
  ModalContainer,
  ModalContent,
  ModalRoot,
} from 'src/components/ui/modal'
import { api } from 'src/services/api'
import { ExtractItem } from 'src/utils/extractDescription'
import type { DevicesProps } from '../authorizedDevices/AutorizedListDevices'
import type { BeneficiaryDataProps } from '../pixOptions/components/NewPix/NewPixForm'
import { BeneficiaryDataStep } from './components/BeneficiaryDataStep'
import { PasswordStep } from './components/PasswordStep'
import { PasteStep } from './components/PasteStep'
import { SuccessStep } from './components/SuccessStep'

export const CopyAndPaste = () => {
  const [beneficiaryData, setBeneficiaryData] = useState<BeneficiaryDataProps>(
    {}
  )
  const [isOpen, setIsOpen] = useState(false)
  const [step, setStep] = useState(1)
  const token = localStorage.getItem('@stricv2:token')
  const [data, setData] = useState<DevicesProps[]>([])
  const [decodedEmv, setDecodedEmv] = useState<any>({})
  const navigate = useNavigate()

  const handleCloseModal = () => {
    setIsOpen(false)
    setStep(1)
  }
  const [transaction, setTransaction] = useState<ExtractItem>()

  const fetchDevices = async () => {
    try {
      // Substituindo a chamada à API por dados fictícios
      const { data: responseData } = await api.get('/devices', {
        headers: { Authorization: `Bearer ${token}` },
      })
      // Transformar o objeto em um array, caso seja um único item
      const deviceArray = Array.isArray(responseData)
        ? responseData
        : [responseData]
      setData(deviceArray)
    } catch (error) {
      console.error('Erro ao buscar os dados:', error)
    }
  }

  useEffect(() => {
    fetchDevices()
  }, [])

  return (
    <section className="w-[80%] flex flex-col px-8">
      <h1 className="text-[20px] font-bold mt-8">Ações</h1>
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="bg-[#FFFFFF] rounded-lg text-[25px] font-bold flex justify-items-start relative w-[300px] py-8 pl-2 shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]"
      >
        Realizar pagamento
        <br />
        copia e cola
        <img
          src={icon}
          alt="icon"
          className="absolute h-20 object-cover right-0 bottom-0"
        />
      </button>
      <ModalRoot open={isOpen} setIsOpen={handleCloseModal}>
        <ModalContainer>
          <ModalContent>
            <ModalClose />
            {step === 1 ? (
              <PasteStep
                setDecodedEmv={setDecodedEmv}
                setBeneficiaryData={setBeneficiaryData}
                nextStep={() => setStep(step + 1)}
                setStep={setStep}
              />
            ) : step === 2 ? (
              <BeneficiaryDataStep
                beneficiaryData={beneficiaryData}
                setBeneficiaryData={setBeneficiaryData}
                nextStep={() => setStep(step + 1)}
              />
            ) : step === 3 ? (
              <PasswordStep
                decodedEmv={decodedEmv}
                setTransaction={setTransaction}
                beneficiaryData={beneficiaryData}
                nextStep={() => setStep(step + 1)}
              />
            ) : step === 4 ? (
              <SuccessStep transactionId={transaction?.id || ''} />
            ) : step === 5 ? (
              <>
                {data.length === 3 ? (
                  <div className="flex flex-col gap-4 items-center p-4">
                    <h1 className="text-[1.875rem] font-bold">
                      Já existem 3 dispositivos cadastrados
                    </h1>
                    <div className="w-full flex gap-3 justify-center">
                      <button
                        type="button"
                        onClick={() => setStep(1)}
                        className="bg-[#004A8A] text-white py-2 px-4 rounded-md"
                      >
                        Voltar
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col gap-4 items-center p-4">
                    <h1 className="text-[1.875rem] font-bold">
                      Dispositivo não cadastrado
                    </h1>
                    <div className="w-full flex gap-3 justify-center">
                      <button
                        type="button"
                        onClick={() =>
                          navigate('/wallet/security-devices/enable')
                        }
                        className="bg-[#004A8A] text-white py-2 px-4 rounded-md"
                      >
                        Cadastrar
                      </button>
                    </div>
                  </div>
                )}
              </>
            ) : null}
          </ModalContent>
        </ModalContainer>
      </ModalRoot>
    </section>
  )
}
